import { HiddenAccessible } from '#UNSAFE_HiddenAccessible';
import { Label } from '#UNSAFE_Label/Label';

type Props = {
  children: string;
  id?: string;
};

export const HiddenLabel = ({ children, id }: Props) => (
  <HiddenAccessible isHidden>
    <Label id={id}>{children}</Label>
  </HiddenAccessible>
);
